import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { getLocalizedAttrValue } from '@grandvisionhq/utils';

function getActiveVariant(product, sku) {
    if (!sku) {
        return product.masterVariant;
    }
    if (product.masterVariant.sku === sku) {
        return product.masterVariant;
    }
    return product.variants.find((variant)=>variant.sku === sku
    ) || product.masterVariant;
}
function getPrice(variant) {
    if (!Array.isArray(variant.prices) || !variant.prices.length || !variant.prices[0]) {
        return undefined;
    }
    const price = variant.prices[0];
    if (!price.discounted) {
        return {
            originalPrice: price.value.centAmount,
            currency: price.value.currencyCode
        };
    }
    const discounted = price.discounted;
    return {
        currency: price.value.currencyCode,
        originalPrice: price.value.centAmount,
        discountedPrice: discounted.value.centAmount
    };
}
function getAvailableQuantity(availability) {
    const channels = availability && availability.channels || {};
    const quantity = Object.entries(channels).map(([_, channel])=>channel && channel.availableQuantity || 0
    ).reduce((acc, val)=>acc + val
    , 0);
    return quantity;
}
function getProductModelName(variant, locale, productType) {
    if (CommerceToolsApi.isLenses(productType)) {
        return getLocalizedAttrValue(variant, 'materialType', locale);
    }
    return variant.name || '';
}

export { getActiveVariant, getAvailableQuantity, getPrice, getProductModelName };
//# sourceMappingURL=helpers.js.map
